import React from 'react'
import { useTranslation } from 'react-i18next'
import { useBusinessCard } from 'components/BusinessCard/context'
import { Section } from 'components/BusinessCard/components/StyledComponents'
import { H6, P } from '@PipelineDeals/shared-react-components'

const DealOwner = () => {
  const { t } = useTranslation()
  const {
    cardMeta: {
      showOnlyFields,
      showEmptyFields
    },
    resource: person
  } = useBusinessCard()

  const showOwner = showOnlyFields.includes('owner')

  if (!showEmptyFields && !showOwner) return null

  return (
    <Section>
      <H6>{t('businessCard.labels.owner')}</H6>
      <P>{person.owner}</P>
    </Section>
  )
}

export default DealOwner
